module.exports = __webpack_public_path__ + "static/media/greencircle.d4334b01.svg";